import { createFileRoute } from '@tanstack/react-router';
import { BenefitCatalogRevisionPage } from './BenefitCatalogRevisionPage';

export const Route = createFileRoute(
  '/_protected/admin/internal-tools/benefit-catalog/$entryId/revisions/$revisionNumber/',
)({
  component: BenefitCatalogRevisionPage,
});
